import React  from 'react';
import PropTypes from 'prop-types';

const DashboardIcon = (props) => {
  const { width, height, isActive } = props;
  let color;
  if (isActive) {
    color = '#FF4200';
  }
  else {
    color = '#AEB2BF';
  }

  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} fill="none" viewBox="0 0 24 20">
      <path fill={color} d="M24 18H0v2h24v-2z"/>
      <path fill={color} d="M4 16h2a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1v9a1 1 0 0 0 1 1z"/>
      <path fill={color} d="M11 16h2a1 1 0 0 0 1-1V1a1 1 0 0 0-1-1h-2a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1z"/>
      <path fill={color} d="M17 10v5a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-5a1 1 0 0 0-1-1h-2a1 1 0 0 0-1 1z"/>
    </svg>
  );
};

DashboardIcon.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  isActive: PropTypes.bool,
};

DashboardIcon.defaultProps = {
  width: 24,
  height: 20,
  isActive: false,
};

export default DashboardIcon;
